import React, { useState } from 'react';
import { Search, Menu, X } from 'lucide-react';
const menuItems = ['Home', 'Organisatie', 'Producten', 'Catalogus', 'Vacatures', 'Contact', 'Intranet'];
export function NavigationBar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  return <nav className="sticky top-0 z-50 w-full bg-white shadow-md" data-id="element-193">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-194">
        <div className="flex items-center justify-between h-20" data-id="element-195">
          {/* Logo */}
          <div className="flex-shrink-0" data-id="element-196">
            <img src="https://cdn.magicpatterns.com/uploads/rgB3HmZEiWkd4rRtiiQA5S/image.png" alt="Plubos Kabeltechniek" className="h-14 w-auto" data-id="element-197" />
          </div>

          {/* Desktop Menu - Centered */}
          <div className="hidden lg:flex items-center justify-center flex-1 mx-8" data-id="element-198">
            <ul className="flex items-center space-x-8" data-id="element-199">
              {menuItems.map(item => <li key={item} data-id="element-200">
                  <a href="#" className="text-slate-700 hover:text-[#2E78B6] font-medium text-sm transition-colors relative after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-0.5 after:bg-[#F57C00] after:transition-all hover:after:w-full" data-id="element-201">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Right side: Search + Mobile toggle */}
          <div className="flex items-center gap-3" data-id="element-202">
            <button className="p-2 text-slate-600 hover:text-[#2E78B6] transition-colors rounded-lg hover:bg-slate-100" aria-label="Zoeken" data-id="element-203">
              <Search className="w-5 h-5" data-id="element-204" />
            </button>

            {/* Mobile menu button */}
            <button className="lg:hidden p-2 text-slate-600 hover:text-[#2E78B6] transition-colors rounded-lg hover:bg-slate-100" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Menu" data-id="element-205">
              {mobileOpen ? <X className="w-6 h-6" data-id="element-206" /> : <Menu className="w-6 h-6" data-id="element-207" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && <div className="lg:hidden border-t border-slate-100 bg-white shadow-lg" data-id="element-208">
          <ul className="px-4 py-4 space-y-1" data-id="element-209">
            {menuItems.map(item => <li key={item} data-id="element-210">
                <a href="#" className="block px-4 py-3 text-slate-700 hover:text-[#2E78B6] hover:bg-slate-50 rounded-lg font-medium text-sm transition-colors" data-id="element-211">
                  {item}
                </a>
              </li>)}
          </ul>
        </div>}
    </nav>;
}